// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Admin_wrap_1w5mm","title":"Admin_title_1V0jT","form":"Admin_form_IygEs","buttonContainer":"Admin_buttonContainer_1iqaV","btn":"Admin_btn_2a_mJ"};